module.exports = "/_next/static/images/95abe3828cc5acca3b13a039e09d5616-icon-3.svg.webp";